import { SwiftSuggestion } from './hooks.types';

export type OptionType = NonNullable<
  NonNullable<SwiftSuggestion['clearing']>['abroadBankInfoList']
>[number];

export interface Option {
  label: string;
  value: string;
  item: OptionType;
}
